<template>
    <div>
            <router-link :to="'/news/' + item.slug.en">
<!--                <img src="/storage/vSHpsbRTzuWCkN9zL6XIUkHHKtm4nQgaJSoQdnhw.jpeg">-->
                <img :src="'/storage/' + item.image" :alt="item.title.en">
                <span class="title-4 color-text-white">{{item.title.en}}</span>
            </router-link>
    </div>
</template>


<script>
    export default {
        props: ['item']
    }
</script>
